export const accessoryData = [
    {
        id: 1,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717398550/spc/shopping_13_yrskbj.webp',
        description: 'Nylon Plain Dog Collar',
    },
    {
        id: 2,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717398446/spc/shopping_10_v5vwrf.webp',
        description: 'Drools Dog Trio Bolt Ring Toy',
    },
    {
        id: 3,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717398550/spc/shopping_12_uxw5gv.webp',
        description: 'Bio-Groom Enhancer Shampoo',
    },
    {
        id: 4,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717398515/spc/shopping_11_xasus5.webp',
        description: 'Pets Way Solid Color Collar',
    },
];